// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width25 {
    width: 25%;
}

.width75 {
    width: 74%;
}

.width40 {
    width: 40px;
    padding: 0px !important;
}

.width200 {
    width: 200px;
}

.ml10 {
    margin-left: 10px;
}

.tableCellTextOverflow {
    max-width: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding: 0px 1rem !important;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/pages/pages.version.settings.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;AAChC","sourcesContent":[".width25 {\n    width: 25%;\n}\n\n.width75 {\n    width: 74%;\n}\n\n.width40 {\n    width: 40px;\n    padding: 0px !important;\n}\n\n.width200 {\n    width: 200px;\n}\n\n.ml10 {\n    margin-left: 10px;\n}\n\n.tableCellTextOverflow {\n    max-width: 0;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    padding: 0px 1rem !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
